<template>
	<h-tab-list>
		<slot></slot>
	</h-tab-list>
</template>
